/**
 * Price slider stops between the floor and the ask.
 *
 * Interior stops land on even $0.05 increments; the two ends are the exact
 * floor and ask (e.g. $10.92, $10.95, $11.00 … $13.55, $13.60). Works when the
 * floor is above the ask too — stops are always ascending.
 */

export const PRICE_STEP = 0.05;

const cents = (n) => Math.round(n * 100) / 100;

export function buildPriceStops(floor, ask, step = PRICE_STEP) {
  if (floor == null || Number.isNaN(floor)) return [];
  if (ask == null || Number.isNaN(ask)) return [cents(floor)];

  const lo = cents(Math.min(floor, ask));
  const hi = cents(Math.max(floor, ask));
  const stops = [lo];
  let n = Math.floor(lo / step + 1e-9) + 1;
  while (cents(n * step) < hi) {
    stops.push(cents(n * step));
    n += 1;
  }
  if (hi > lo) stops.push(hi);
  return stops;
}

/**
 * Slider position is stored as 0 (floor) → 1 (ask) so it survives changes to
 * qty / garment / decoration: "at the ask" stays at the ask.
 */
export function stopIndexForPosition(stops, floor, ask, position) {
  if (stops.length <= 1) return 0;
  const floorIndex = floor <= ask ? 0 : stops.length - 1;
  const askIndex = floor <= ask ? stops.length - 1 : 0;
  const p = Math.min(1, Math.max(0, Number(position)));
  return Math.round(floorIndex + p * (askIndex - floorIndex));
}

export function positionForStopIndex(stops, floor, ask, index) {
  if (stops.length <= 1) return 1;
  const floorIndex = floor <= ask ? 0 : stops.length - 1;
  const askIndex = floor <= ask ? stops.length - 1 : 0;
  return (index - floorIndex) / (askIndex - floorIndex);
}
